import {axios} from '@/utils/request'
export function Post (Url,data,parameter) {
  return axios({
    url: Url,
    method: 'post',
    data: data,
    params: parameter
  })
}
export function Get (Url,parameter) {
  return axios({
    url: Url,
    method: 'get',
    params: parameter
  })
}
export function ExportQuestion() {
	return axios({
		url: '/DM/ExportQuestion',
		method: 'get',
		responseType: 'blob'
	})
}
export function ExportPIPrice(data) {
	return axios({
		url: '/DM/ExportPIPrice',
		method: 'post',
		responseType: 'blob',
		data: data,
	})
}
export function Download(fId){
	var parameter = {
		FId: fId,
	}
	return axios({
		url: '/api/DownPriceFile',
		method: 'get',
		params: parameter,
		responseType: 'blob'
	})
}
export function DownloadFile1(res,fileName) {
	var blob = new Blob([res.data], {
		type: 'application/octet-stream;charset=UTF-8'
	})
	var filename=fileName
	var downloadElement = document.createElement('a')
	var href = window.URL.createObjectURL(blob) // 创建下载的链接
	var reg = /^["](.*)["]$/g
	downloadElement.style.display = 'none'
	downloadElement.href = href
	downloadElement.download = decodeURI(filename.replace(reg, '$1')) // 下载后文件名
	document.body.appendChild(downloadElement)
	downloadElement.click() // 点击下载
	document.body.removeChild(downloadElement) // 下载完成移除元素
	window.URL.revokeObjectURL(href)
}
/**
 * 下载
 */
export function DownloadFile(res) {
	var blob = new Blob([res.data], {
		type: 'application/octet-stream;charset=UTF-8'
	})
	var contentDisposition = res.headers['content-disposition']
	//attachment; filename=__.xlsx; filename*=UTF-8''职务.xlsx
	console.log(contentDisposition)
	var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
	var result = patt.exec(contentDisposition)
	var filename = result[1]
	var downloadElement = document.createElement('a')
	var href = window.URL.createObjectURL(blob) // 创建下载的链接
	var reg = /^["](.*)["]$/g
	downloadElement.style.display = 'none'
	downloadElement.href = href
	downloadElement.download = decodeURI(filename.replace(reg, '$1')) // 下载后文件名
	document.body.appendChild(downloadElement)
	downloadElement.click() // 点击下载
	document.body.removeChild(downloadElement) // 下载完成移除元素
	window.URL.revokeObjectURL(href)
}